import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { cases } from "@/mocks/cases";
import { formatHeat } from "@/utils/format";

const watchTips = [
  { icon: "ri-time-line", text: "先看时间线能不能自洽，再看结论。" },
  { icon: "ri-links-line", text: "只认能回到原始发布的截图与录音。" },
  { icon: "ri-user-voice-line", text: "当事方的公开说明一并读，再下判断。" },
];

export default function RankSection() {
  const ranked = [...cases].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <section id="rank" className="w-full bg-background-100 border-y border-background-200">
      <div className="px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          eyebrow="Hot Board"
          title="档案热度榜"
          desc="热度来自站内阅读与讨论量，只代表关注度，不代表可信度。点开任意一条，仍要自己核对材料。"
          actionHref="/archive"
          actionLabel="查看完整榜单"
        />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <ol className="lg:col-span-8 flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
            {ranked.map((item, index) => (
              <li key={item.id}>
                <Link
                  to={`/archive/${item.id}`}
                  className="group flex items-center gap-4 px-4 md:px-6 py-4 md:py-5 hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <span
                    className={`flex w-9 h-9 shrink-0 items-center justify-center rounded-md font-heading font-bold ${
                      index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-700 transition-colors line-clamp-1">
                      {item.title}
                    </h3>
                    <p className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                      <span>{item.categoryName}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-links-line" />
                        {item.evidences.join(" / ")}
                      </span>
                    </p>
                  </div>
                  <span className="hidden sm:flex items-center gap-1.5 text-sm text-primary-600 shrink-0">
                    <i className="ri-fire-fill" />
                    {formatHeat(item.heat)}
                  </span>
                  <i className="ri-arrow-right-s-line text-lg text-foreground-400 group-hover:text-primary-600 transition-colors" />
                </Link>
              </li>
            ))}
          </ol>

          <aside className="lg:col-span-4 rounded-lg border border-secondary-200 bg-secondary-50 p-6 flex flex-col">
            <span className="flex w-11 h-11 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-shield-star-line text-xl" />
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">理性围观三原则</h3>
            <ul className="mt-4 flex flex-col gap-3.5 flex-1">
              {watchTips.map((tip) => (
                <li key={tip.text} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700">
                  <i className={`${tip.icon} mt-0.5 text-secondary-600`} />
                  {tip.text}
                </li>
              ))}
            </ul>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-secondary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-secondary-600 transition-colors cursor-pointer"
            >
              看看我们的编辑流程
              <i className="ri-arrow-right-line" />
            </Link>
          </aside>
        </div>
      </div>
    </section>
  );
}